module.exports = __webpack_public_path__ + "img/icon_join_holiday@2x.1bd551b7.png";